import { render, staticRenderFns } from "./VersionManage.vue?vue&type=template&id=f6731692&scoped=true&"
import script from "./VersionManage.vue?vue&type=script&lang=js&"
export * from "./VersionManage.vue?vue&type=script&lang=js&"
import style0 from "./VersionManage.vue?vue&type=style&index=0&id=f6731692&lang=css&scoped=true&"
import style1 from "./VersionManage.vue?vue&type=style&index=1&id=f6731692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6731692",
  null
  
)

export default component.exports